module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"var(--color-blue)","showSpinner":false},
    },{
      plugin: require('../../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://498725ce14de433db500d639f13bf207@o301206.ingest.sentry.io/5409390","environment":"production","debug":false,"enabled":true,"allowUrls":[{}]},
    },{
      plugin: require('../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/favicon.png","name":"Hem","short_name":"Hem","start_url":"/","background_color":"#2326DE","theme_color":"#FFFFFF","display":"standalone","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1c23b796b0a9b8ed7977f096fad5ad7a"},
    },{
      plugin: require('../../gatsby-theme-hem-store/gatsby-browser.js'),
      options: {"plugins":[],"contentful":{"environment":"hem.com","locale":"en-CA"}},
    },{
      plugin: require('../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
